import type { FieldType, IScenarioSubJob } from '@/interfaces'

import { addToJSON } from './helper'

export class ScenarioSubJob implements IScenarioSubJob {
	[key: string]: FieldType
	id: number
	revision: number
	subjobId: number
	subjobNumber: string
	subjobType: string
	code: number
	estimatedHours: number | null
	contractValue: number | null
	estimatedContractSource: string
	buildLocation: string
	dueDate: Date
	shipDate: Date | string
	productionKickoffDate: Date | string
	designDate: Date
	estimatingKickoffDate: Date
	detailingDate: Date
	signedQuoteWODate: Date
	graphicsDate: Date
	postShowReviewDate: Date
	subjobDueDate: string | Date | null
	subjobStartDate: string | Date | null
	clientName: string
	showName: string
	subjobDisplayName: string
	probabilityOfSales: string
	timeline: string
	createBy: number
	createByEmail: string
	createDatetime: Date
	updateBy: number
	updateByEmail: string
	updateDatetime: Date
	comitted: Date | string
	notes: string
	isDeleted: boolean
	isValid: boolean
	isPrimary: boolean
	weightedHoursOverride: boolean

	constructor({
		id,
		revision,
		subjobId,
		subjobNumber,
		subjobType,
		code,
		estimatedHours,
		contractValue,
		estimatedContractSource,
		buildLocation,
		dueDate,
		shipDate,
		productionKickoffDate,
		designDate,
		estimatingKickoffDate,
		detailingDate,
		signedQuoteWODate,
		graphicsDate,
		postShowReviewDate,
		subjobDueDate,
		subjobStartDate,
		clientName,
		showName,
		subjobDisplayName,
		probabilityOfSales,
		timeline,
		createBy,
		createByEmail,
		createDatetime,
		updateBy,
		updateByEmail,
		updateDatetime,
		comitted,
		notes,
		isDeleted,
		isValid,
		isPrimary,
		weightedHoursOverride
	}: IScenarioSubJob) {
		this.id = id || 0
		this.revision = revision || 0
		this.subjobId = subjobId || 0
		this.subjobNumber = subjobNumber || ''
		this.subjobType = subjobType || ''
		this.code = code || 0
		this.estimatedHours = estimatedHours || null
		this.contractValue = contractValue || null
		this.estimatedContractSource = estimatedContractSource || ''
		this.buildLocation = buildLocation || ''
		this.dueDate = dueDate
		this.shipDate = shipDate
		this.productionKickoffDate = productionKickoffDate || ''
		this.designDate = designDate
		this.estimatingKickoffDate = estimatingKickoffDate
		this.detailingDate = detailingDate
		this.signedQuoteWODate = signedQuoteWODate
		this.graphicsDate = graphicsDate
		this.postShowReviewDate = postShowReviewDate
		this.subjobDueDate = subjobDueDate || ''
		this.subjobStartDate = subjobStartDate || ''
		this.clientName = clientName || ''
		this.showName = showName || ''
		this.subjobDisplayName = subjobDisplayName || ''
		this.probabilityOfSales = probabilityOfSales || ''
		this.timeline = timeline || ''
		this.createBy = createBy || 0
		this.createByEmail = createByEmail || ''
		this.createDatetime = createDatetime || new Date()
		this.updateBy = updateBy || 0
		this.updateByEmail = updateByEmail || ''
		this.updateDatetime = updateDatetime || new Date()
		this.comitted = comitted
		this.notes = notes || ''
		this.isDeleted = isDeleted || false
		this.isValid = isValid || true
		this.isPrimary = isPrimary || true
		this.weightedHoursOverride = weightedHoursOverride || false
		addToJSON(ScenarioSubJob)
	}

	toJSON(): string {
		// this will be overridden by the addToJSON method
		return ''
	}
}
